module.exports = "https://static.energy5.com/_next/static/images/businessManager-c51ec77806b497e71f184a8920ad42c7.webp";